
import { Component, Mixins } from "vue-property-decorator";
import { ObjectKeys, IConfiguration, IFormatEditorStyleFormatEditorObjectConfiguration } from "../../../../domain/configuration";
import { IFormatObjectEditable } from "../../../../domain/editableFormat";
import { ElementTypes } from "../../../../domain/editableFormat/objects";
import { default as FormatStructureEditorStoreReferableMixin } from "./FormatStructureEditorStoreReferableMixin.vue";
import { default as CommonComponentsAccessibleMixin } from "./CommonComponentsAccessibleMixin.vue";

@Component
export default class FormatObjectEditableMixin extends Mixins(FormatStructureEditorStoreReferableMixin, CommonComponentsAccessibleMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IFormatObjectEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IFormatObjectEditable) => T, defaultValue: T) => T;

  data() {
    return {
      styleKey: undefined as ObjectKeys,
    };
  }
  styleKey: ObjectKeys;

  $configuration!: IConfiguration;

  get configuration(): IFormatEditorStyleFormatEditorObjectConfiguration {
    return this.$configuration.formatEditor.style.format.editor.objects[this.styleKey];
  }

  get objectTypeName(): ElementTypes {
    return this.readPropertyOrDefault(s => s.objectTypeName().getValue(), null);
  }

  get isSelected(): boolean {
    return this.readPropertyOrDefault(s => s.isSelected(), false);
  }

  select(): void {
    this.writePropertyWhenValid(s => s.select());
  }

  deselect(): void {
    this.writePropertyWhenValid(s => s.deselect());
  }
}
